<script setup lang="ts">
import { numHelper } from '@/utils/numHelper.ts'
import { computed } from 'vue'

interface Props {
  percent?: number | string | null;
  amount?: number | string | null;
}

const props = defineProps<Props>();

const percent = computed(() => (props.percent ? numHelper(props.percent).format(2) : '--'));
const amount = computed(() => (props.amount ? numHelper(props.amount).format(0, ',', '.') : '--'));
const amountText = computed(() => (props.amount ? numHelper(props.amount).numberToVietnameseText() : '--'));
</script>

<template>
  <div class="commission-amount">
    <div class="percent"><span>{{percent}}</span><sup>%</sup></div>
    <Divider layout="vertical"/>
    <div class="amount">
      <span class="block font-bold">{{amount}} <sup>đ</sup></span>
      <span class="block text-[11px] font-italic text-[#FF0000]">{{amountText}}</span>
    </div>
  </div>
</template>

<style lang="scss">
.commission-amount{
  display: flex;
  .percent{
    font-size: .8rem;
    span{
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}
</style>
